import React from 'react';
import styled, { css } from 'styled-components';

interface Breakpoints {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
}

type Props = {
  children: any;
  flex?: boolean;
  justify?: string;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
};

const breakpoints: Breakpoints = {
  xs: '0px',
  sm: '600px',
  md: '960px',
  lg: '1280px',
  xl: '1920px',
};

export const Grid = ({
  children,
  xs,
  sm,
  md,
  lg,
  xl,
  flex = false,
  justify = 'flex-start',
}: Props): JSX.Element => {
  return (
    <Container
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
      $flex={flex}
      $justify={justify}
    >
      {children}
    </Container>
  );
};

const Container = styled.div<{
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  $flex?: boolean;
  $justify?: string;
}>`
  display: ${({ $flex }) => ($flex ? 'flex' : 'block')};
  justify-content: ${({ $justify }) => $justify};
  flex-wrap: wrap;
  max-height: 100%;
  ${(props: any) =>
    Object.keys(breakpoints).map((breakpoint) => {
      const value = props[breakpoint];
      if (value) {
        return css`
          @media (min-width: ${breakpoints[breakpoint as keyof Breakpoints]}) {
            width: ${(value / 12) * 100}%;
          }
        `;
      }
    })}
`;
